// Переключатель «Zepp с поправкой»: рисуется только там, где есть поправка (хотя бы одна пара).

export function ZeppToggle({ checked, onChange }: { checked: boolean; onChange: (value: boolean) => void }) {
  return (
    <label className="flex min-h-11 items-center gap-2 text-sm text-fg lg:min-h-10">
      <input
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        className="h-4 w-4 accent-[var(--accent)]"
      />
      Zepp с поправкой
    </label>
  )
}
